import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
/* eslint-disable react-hooks/exhaustive-deps */
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useAnnouncementsHistory } from "../apis";

const useAnnouncementsHistoryList = () => {
  const { page, searchValue, debouncedSearch, setSearchValue, setPage } =
    useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch
  };

  const { announcementsHistory, meta, isLoading } =
    useAnnouncementsHistory(requestParams);

  return {
    announcementsHistory,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    setSearchValue,
    setPage
  };
};

export default useAnnouncementsHistoryList;
